module.exports = __webpack_public_path__ + "img/main_header1.fd529365.svg";